import {FETCH_EMPLOYMENTS_REQUEST, FETCH_EMPLOYMENTS_SUCCES, FETCH_EMPLOYMENTS_ERROR} from '../constants/Employments'

const initialState = {
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function employments(state = initialState, action) {
  switch (action.type) {
      case FETCH_EMPLOYMENTS_REQUEST:
        return {...state, isLoading: true};
      case FETCH_EMPLOYMENTS_SUCCES:
        return {...state, list: action.payload.results, isLoading: false};
      case FETCH_EMPLOYMENTS_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employments.js